import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import { Grid, List, ListItemButton } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  WsButton,
  WsTitleBanner,
  WsColors,
  WsIconText,
  WsTypoVariants,
  TabTextVariant,
  ScrollableTabs,
  WsIconAssignCandidate,
  WsElementWithPopOver,
} from 'wisestep-base';

import { useInvoicingAuthz, InvoicingAction } from '../../../hooks/useInvoicingAuthz';

import InvoiceList from './InvoiceList';

const FEATURE_CONTRACTOR_INVOICE = process.env.REACT_APP_FEATURE_CONTRACTOR_INVOICE === 'true';

interface IInvoiceList {
  requireHeaderBanner?: boolean;
}

const InvoiceListingPage = ({ requireHeaderBanner = true }: IInvoiceList) => {
  const [tabPanelPage, setTabPanelPage] = useState(0);
  const navigate = useNavigate();
  const isAuthorizedViewInvoicingAll = useInvoicingAuthz(InvoicingAction.VIEW_INVOICE_LISTING_PAGE);
  const isAuthorizedAddInvoicing = useInvoicingAuthz(InvoicingAction.ADD_INVOICE_ADDITION);

  const onChangeTab = (index) => {
    setTabPanelPage(index);
  };

  return (
    <Grid container sx={{ display: 'flex', backgroundColor: WsColors.TheBlues50 }}>
      {requireHeaderBanner && (
        <>
          <Grid item xs={12}>
            <WsTitleBanner title="Invoicing" backButton={false} showBetaIcon={true} />
          </Grid>
          {isAuthorizedAddInvoicing && (
            <Grid item xs={12} px={2} py={1} container justifyContent="flex-end">
              <Grid item xs={2} p={1} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <WsElementWithPopOver
                  element={
                    <WsButton
                      variant="contained"
                      size="medium"
                      endIcon={<KeyboardArrowDownOutlinedIcon />}
                    >
                      Create Invoice
                    </WsButton>
                  }
                >
                  <List dense={true} sx={{ pl: 1 }}>
                    {FEATURE_CONTRACTOR_INVOICE && (
                      <ListItemButton
                        onClick={() => navigate('/invoice/add?placementType=CONTRACTOR')}
                      >
                        <WsIconText
                          text="Contractor Invoice"
                          icon={<WsIconAssignCandidate />}
                          textCursor="pointer"
                          textSize={WsTypoVariants.BODY1}
                        />
                      </ListItemButton>
                    )}
                    <ListItemButton onClick={() => navigate('/invoice/addoptions')}>
                      <WsIconText
                        text="Permanent Invoice"
                        icon={<WsIconAssignCandidate />}
                        textCursor="pointer"
                        textSize={WsTypoVariants.BODY1}
                      />
                    </ListItemButton>
                  </List>
                </WsElementWithPopOver>
              </Grid>
            </Grid>
          )}
        </>
      )}
      <ScrollableTabs
        variant={TabTextVariant.SUB_TITLE}
        scrollList={[
          { tabName: 'Permanent Invoices' },
          {
            ...((FEATURE_CONTRACTOR_INVOICE && { tabName: 'Contractor Invoices' }) as {
              tabName: string;
            }),
          },
        ]}
        getTabIndex={(index: number) => onChangeTab(index)}
        defaultValue={tabPanelPage}
      />
      {isAuthorizedViewInvoicingAll && (
        <Grid item xs={12} sx={{ backgroundColor: 'common.white', p: 2 }}>
          {tabPanelPage == 0 && <InvoiceList placementType="PERMANENT" />}
          {tabPanelPage == 1 && <InvoiceList placementType="CONTRACTOR" />}
        </Grid>
      )}
    </Grid>
  );
};

export default InvoiceListingPage;
